module.exports = __webpack_public_path__ + "img/NYC-N-NEW.6667bc6c.jpg";